<template>
  <div class="vedio">
    <aboutNav></aboutNav>
    <div class="vedioGroup container">
      <div v-if="loading" class="loading">加载中...</div>

      <ul v-else>
        <li
          v-for="(item, index) in currentPageData"
          @click="showIframe(item.video)"
          :key="index"
        >
          <img
            :src="'https://img.duoduiduo.com/' + item.image_url"
            alt="多对多物联平台"
          />
          <div class="title">{{ item.title }}</div>
        </li>

        <!-- 填充空位保持布局 -->
        <template v-if="currentPageData.length < pageSize">
          <li
            v-for="n in pageSize - currentPageData.length"
            :key="'empty-' + n"
            class="empty-item"
          ></li>
        </template>
      </ul>

      <!-- 分页控件 -->
      <div class="page" v-if="total > 0">
        <ul>
          <li @click="prevPage" :class="{ disabled: currentPage == 1 }">
            上一页
          </li>

          <li
            v-for="page in visiblePages"
            :key="page"
            :class="{ on: currentPage == page }"
            @click="goToPage(page)"
          >
            {{ page }}
          </li>

          <li
            @click="nextPage"
            :class="{ disabled: currentPage == totalPages }"
          >
            下一页
          </li>
        </ul>

        <!-- <div class="page-info">
          第 {{ currentPage }} 页 / 共 {{ totalPages }} 页（{{ total }} 条记录）
        </div> -->
      </div>

      <!-- 视频弹窗 -->
      <div :class="['vedioBox', iframeShow ? 'show' : '']">
        <div class="video-container">
          <video
            id="vedio"
            controls
            :src="iframeSrc"
            x5-video-orientation="portraint"
            style="object-fit: fill"
            autoplay
          ></video>
        </div>
        <div class="close" @click="closeIframe">
          <i class="icon-close"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import aboutNav from "./aboutNav";

export default {
  name: "vedioGroup",
  components: {
    aboutNav,
  },
  metaInfo: {
    meta: [
      {
        name: "keywords",
        content: "多对多物联集团、银发经济、人口老龄化...",
      },
      {
        name: "discription",
        content:
          "多对多物联集团是一家深耕于大健康领域多年的健康管理数智服务商...",
      },
    ],
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 6,
      total: 0,
      iframeShow: false,
      iframeSrc: "",
      currentPageData: [],
      loading: false,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize);
    },
    visiblePages() {
      const pages = [];
      const maxVisible = 5;
      let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
      let end = Math.min(this.totalPages, start + maxVisible - 1);

      if (end - start + 1 < maxVisible) {
        start = Math.max(1, end - maxVisible + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    },
  },
  created() {
    if (this.$route.query.name == "why") {
      this.$nextTick(() => {
        setTimeout(() => {
          var height = document.getElementById("header").clientHeight;
          document.documentElement.scrollTop = height;
        }, 10);
      });
    }
  },
  mounted() {
    this.getVideos();
  },
  methods: {
    getVideos() {
      this.loading = true;
      this.sendHttp({
        url: "https://sys.duoduiduo.com/videocourse/getvideopage",
        method: "post",
        data: {
          page: this.currentPage,
          limit: this.pageSize,
          type: 2,
        },
      })
        .then((res) => {
          if (res.code == 0) {
            this.currentPageData = res.data || [];
            this.total = res.count;

            // 如果当前页没有数据且不是第一页，自动返回上一页
            if (this.currentPageData.length === 0 && this.currentPage > 1) {
              this.currentPage--;
              this.getVideos();
              return;
            }
          } else {
            console.error("API error:", res.message);
            this.$message.error("获取视频列表失败: " + res.message);
          }
        })
        .catch((error) => {
          console.error("Request failed:", error);
          this.$message.error("网络请求失败，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    goToPage(page) {
      if (page !== this.currentPage) {
        this.currentPage = page;
        this.getVideos();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getVideos();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getVideos();
      }
    },

    showIframe(src) {
      this.iframeSrc = "https://img.duoduiduo.com/" + src;
      this.iframeShow = true;
      document.body.style.overflow = "hidden";
    },
    closeIframe() {
      this.iframeShow = false;
      this.iframeSrc = "";
      document.body.style.overflow = "";
      const video = document.getElementById("vedio");
      if (video) {
        video.pause();
      }
    },
    handleImageError(e) {
      e.target.src = this.defaultImage;
    },
  },
};
</script>

<style scoped lang="less">
.vedio {
  box-shadow: 0 10px 10px -3px #efefef;
  min-height: 500px;

  .loading {
    text-align: center;
    padding: 50px;
    font-size: 16px;
    color: #666;
  }
}

.vedioGroup {
  position: relative;
  padding-bottom: 100px;
  padding-top: 4%;

  ul {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      width: 30%;
      text-align: center;
      margin-bottom: 50px;
      cursor: pointer;
      transition: transform 0.3s;

      &:hover {
        transform: translateY(-5px);
      }

      img {
        width: 100%;
        height: 180px;
        object-fit: cover;
        border-radius: 4px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        margin-bottom: 10px;
      }

      .title {
        padding: 0 15px;
        line-height: 26px;
        font-size: 16px;
        color: #333;
        height: 52px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      &.empty-item {
        visibility: hidden;
      }

      @media (max-width: 1200px) {
        img {
          height: 160px;
        }
      }

      @media (max-width: 992px) {
        img {
          height: 140px;
        }
      }

      @media (max-width: 768px) {
        width: 46%;
        margin-bottom: 30px;

        img {
          height: 160px;
        }
      }

      @media (max-width: 576px) {
        margin-bottom: 20px;

        img {
          height: 140px;
        }

        .title {
          font-size: 14px;
          height: 42px;
        }
      }
    }
  }

  .page {
    padding-top: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;

    ul {
      display: flex;
      justify-content: center;
      margin-bottom: 15px;
      width: auto;

      li {
        width: auto;
        min-width: 36px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        margin: 0 5px;
        padding: 0 12px;
        border: 1px solid #ee8835;
        border-radius: 4px;
        color: #ee8835;
        cursor: pointer;
        transition: all 0.3s;

        &:hover:not(.disabled) {
          background: rgba(238, 136, 53, 0.1);
        }

        &.on {
          background: #ee8835;
          color: #fff;
        }

        &.disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      }
    }

    .page-info {
      text-align: center;
      color: #666;
      font-size: 14px;
    }
  }

  .vedioBox {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    z-index: 1000;
    display: none;
    align-items: center;
    justify-content: center;

    &.show {
      display: flex;
    }

    .video-container {
      width: 80%;
      max-width: 1000px;
      position: relative;

      #vedio {
        width: 100%;
        height: auto;
        max-height: 80vh;
        border-radius: 4px;
      }
    }

    .close {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        background: rgba(255, 255, 255, 0.3);
      }

      .icon-close {
        display: inline-block;
        width: 20px;
        height: 20px;
        background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23ffffff'%3E%3Cpath d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/%3E%3C/svg%3E")
          no-repeat center;
        background-size: contain;
      }
    }

    @media (max-width: 768px) {
      .video-container {
        width: 95%;
      }

      .close {
        top: 10px;
        right: 10px;
        width: 30px;
        height: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/about/videogroup.vue